import utils from "../../../utils/utils";
export default {
    async fetchConnectedPages(context, payload) {
       const response = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?source=${payload.source}&accountType=${payload.accountType}&pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);        
        context.commit("setConnectedPages", response.data);
    },
    async fetchConnectedWalls(context, payload) {
       const response = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?source=${payload.source}&accountType=${payload.accountType}&pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);        
        context.commit("setConnectedWalls", response.data);
    },
    async fetchClientDetails(context) {
       const response = await utils.utility.fetch("api/Setting/GetFacebookDefinition","GET",null, null);      
       context.commit("setClientDetails", response.data);
    },
    async deleteAccount(_,payload){
        await utils.utility.fetch("api/Setting/DeleteSocialMediaAccount","PUT",null, payload);        
    },
    async addWall(_,payload){
        await utils.utility.fetch("api/Setting/AddFacebookWall","POST",null, payload);        
    },
    async fetchFacebookPages(context,payload){
        const response = await utils.utility.fetch(`api/Setting/GetFacebookPages?state=${payload.state}`,"GET",null,null);
        context.commit("setRetrivedPages",response.data);
    },
    async addFacebookPage(context,payload){
         await utils.utility.fetch(`api/Setting/AddFacebookPage`,"POST",null, payload);
         const updatedPages = context.state.retrievedFacebookPages.filter(page => String(page.id) !== payload.pageId);         
         context.commit("setRetrivedPages", updatedPages);  
    }            

}